// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Formality = require("../../vendor/re-formality/Formality.bs.js");
var Core__List = require("@rescript/core/src/Core__List.bs.js");
var Attachments = require("../../reason/common/Attachments/Attachments.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");

var validators_attachments = {
  strategy: "OnFirstChange",
  validate: (function (param) {
      var attachments = param.attachments;
      var uploadedAttachments = Core__Array.filterMap(attachments, (function (x) {
              var attachment = x.state;
              if (attachment.TAG === "Success") {
                return attachment._0;
              }
              
            }));
      if (uploadedAttachments.length === attachments.length) {
        return {
                TAG: "Ok",
                _0: uploadedAttachments
              };
      } else if (attachments.some(function (x) {
              switch (x.state.TAG) {
                case "NotStarted" :
                case "InProgress" :
                    return true;
                case "Failed" :
                case "Success" :
                    return false;
                
              }
            })) {
        return {
                TAG: "Error",
                _0: "UPLOAD_FAILED"
              };
      } else {
        return {
                TAG: "Error",
                _0: "UPLOAD_IN_PROGRESS"
              };
      }
    })
};

var validators_text = {
  strategy: "OnFirstChange",
  validate: (function (param) {
      var text = param.text.trim();
      if (text === "") {
        if (param.attachments.length !== 0) {
          return {
                  TAG: "Ok",
                  _0: undefined
                };
        } else {
          return {
                  TAG: "Error",
                  _0: "EMPTY_MESSAGE"
                };
        }
      } else {
        return {
                TAG: "Ok",
                _0: text
              };
      }
    })
};

var validators = {
  attachments: validators_attachments,
  text: validators_text
};

function initialFieldsStatuses(_input) {
  return {
          attachments: "Pristine",
          text: "Pristine"
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            attachments: "Pristine",
            text: "Pristine"
          },
          collectionsStatuses: undefined,
          formStatus: "Editing",
          submissionStatus: "NeverSubmitted"
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.attachments;
  var tmp;
  tmp = typeof match !== "object" ? validators.attachments.validate(input) : match._0;
  var match$1 = fieldsStatuses.text;
  var tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.text.validate(input) : match$1._0;
  var attachmentsResult = tmp;
  var attachmentsResult$1;
  if (attachmentsResult.TAG === "Ok") {
    var textResult = tmp$1;
    if (textResult.TAG === "Ok") {
      return {
              TAG: "Valid",
              output: {
                text: textResult._0,
                attachments: attachmentsResult._0
              },
              fieldsStatuses: {
                attachments: {
                  TAG: "Dirty",
                  _0: attachmentsResult,
                  _1: "Shown"
                },
                text: {
                  TAG: "Dirty",
                  _0: textResult,
                  _1: "Shown"
                }
              },
              collectionsStatuses: undefined
            };
    }
    attachmentsResult$1 = attachmentsResult;
  } else {
    attachmentsResult$1 = attachmentsResult;
  }
  return {
          TAG: "Invalid",
          fieldsStatuses: {
            attachments: {
              TAG: "Dirty",
              _0: attachmentsResult$1,
              _1: "Shown"
            },
            text: {
              TAG: "Dirty",
              _0: tmp$1,
              _1: "Shown"
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action !== "object") {
            switch (action) {
              case "BlurAttachmentsField" :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.attachments, validators_attachments, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  attachments: status,
                                  text: init.text
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurTextField" :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.text, validators_text, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  attachments: init.attachments,
                                  text: status
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "Submit" :
                  var match = state.formStatus;
                  if (typeof match === "object" && match.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== "Valid") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: "AttemptedToSubmit"
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: "UpdateWithSideEffects",
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: "Submitting",
                              _0: tmp
                            },
                            submissionStatus: "AttemptedToSubmit"
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              onSubmit(output, {
                                    notifyOnSuccess: (function (input) {
                                        dispatch({
                                              TAG: "SetSubmittedStatus",
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        dispatch({
                                              TAG: "SetSubmissionFailedStatus",
                                              _0: error
                                            });
                                      }),
                                    reset: (function () {
                                        dispatch("Reset");
                                      }),
                                    dismissSubmissionResult: (function () {
                                        dispatch("DismissSubmissionResult");
                                      })
                                  });
                            })
                        };
                  break;
              case "DismissSubmissionError" :
                  var match$2 = state.formStatus;
                  if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
                    return "NoUpdate";
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "DismissSubmissionResult" :
                  var match$3 = state.formStatus;
                  if (typeof match$3 !== "object") {
                    if (match$3 === "Editing") {
                      return "NoUpdate";
                    }
                    
                  } else if (match$3.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: "Editing",
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "Reset" :
                  return {
                          TAG: "Update",
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG) {
              case "UpdateAttachmentsField" :
                  var nextInput = action._0(state.input);
                  var nextFieldsStatuses = {
                    contents: state.fieldsStatuses
                  };
                  var result$2 = Formality.validateDependentFieldOnChange(nextInput, nextFieldsStatuses.contents.text, validators_text, (function (status) {
                          var init = nextFieldsStatuses.contents;
                          return {
                                  attachments: init.attachments,
                                  text: status
                                };
                        }));
                  if (result$2 !== undefined) {
                    nextFieldsStatuses.contents = result$2;
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, nextFieldsStatuses.contents.attachments, state.submissionStatus, validators_attachments, (function (status) {
                                    var init = nextFieldsStatuses.contents;
                                    return {
                                            attachments: status,
                                            text: init.text
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateTextField" :
                  var nextInput$1 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.text, state.submissionStatus, validators_text, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            attachments: init.attachments,
                                            text: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "SetSubmittedStatus" :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                attachments: "Pristine",
                                text: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                attachments: "Pristine",
                                text: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "SetSubmissionFailedStatus" :
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: "SubmissionFailed",
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "MapSubmissionError" :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 !== "object") {
                    return "NoUpdate";
                  }
                  if (error$1.TAG !== "Submitting") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "SubmissionFailed",
                                _0: map(error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "Submitting",
                                _0: Caml_option.some(map(Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 !== "object" || match$1.TAG !== "Submitting" ? false : true;
  return {
          updateAttachments: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateAttachmentsField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateText: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateTextField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          blurAttachments: (function () {
              dispatch("BlurAttachmentsField");
            }),
          blurText: (function () {
              dispatch("BlurTextField");
            }),
          attachmentsResult: Formality.exposeFieldResult(state.fieldsStatuses.attachments),
          textResult: Formality.exposeFieldResult(state.fieldsStatuses.text),
          input: state.input,
          status: state.formStatus,
          dirty: (function () {
              var match = state.fieldsStatuses;
              var tmp = match.attachments;
              if (typeof tmp === "object") {
                return true;
              }
              var tmp$1 = match.text;
              if (typeof tmp$1 !== "object") {
                return false;
              } else {
                return true;
              }
            }),
          valid: (function () {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === "Valid") {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function () {
              dispatch("Submit");
            }),
          dismissSubmissionError: (function () {
              dispatch("DismissSubmissionError");
            }),
          dismissSubmissionResult: (function () {
              dispatch("DismissSubmissionResult");
            }),
          mapSubmissionError: (function (map) {
              dispatch({
                    TAG: "MapSubmissionError",
                    _0: map
                  });
            }),
          reset: (function () {
              dispatch("Reset");
            })
        };
}

function useWithAttachments(onSubmit, onUnsupportedFileError) {
  var clearAttachments = React.useRef(undefined);
  var form = useForm({
        text: "",
        attachments: []
      }, (function (state, param) {
          var reset = param.reset;
          var reset$1 = function () {
            reset();
            Core__Option.getOr(Core__Option.map(clearAttachments.current, (function (f) {
                        f();
                      })), undefined);
          };
          onSubmit(state, reset$1, param.notifyOnFailure, param.notifyOnSuccess);
        }));
  var attachments$p = Attachments.useAttachments((function (attachments) {
          form.updateAttachments((function (input, attachments) {
                  return {
                          text: input.text,
                          attachments: attachments
                        };
                }), Core__List.toArray(attachments));
        }), Core__List.fromArray(form.input.attachments), onUnsupportedFileError);
  React.useEffect((function () {
          clearAttachments.current = attachments$p.clearAll;
        }), []);
  return [
          form,
          attachments$p
        ];
}

var initialCollectionsStatuses;

exports.validators = validators;
exports.initialFieldsStatuses = initialFieldsStatuses;
exports.initialCollectionsStatuses = initialCollectionsStatuses;
exports.initialState = initialState;
exports.validateForm = validateForm;
exports.useForm = useForm;
exports.useWithAttachments = useWithAttachments;
/* react Not a pure module */
